// Icona "Cambia tavolo": freccia verso destra che entra in un vassoio aperto
export default function MoveTableIconStrong({ size = 24, color = "currentColor" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* freccia verso destra */}
      <path
        d="M9 7h8.586l-2.293-2.293L16 4l4 4-4 4-.707-.707L17.586 9H9V7Z"
        fill={color}
      />
      {/* vassoio aperto */}
      <path
        d="M4 20a2 2 0 0 1-2-2v-4h2v4h16v-4h2v4a2 2 0 0 1-2 2H4Z"
        fill={color}
      />
    </svg>
  );
}
